"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreditLinePartnerType = void 0;
var CreditLinePartnerType;
(function (CreditLinePartnerType) {
    CreditLinePartnerType[CreditLinePartnerType["ApiPartner"] = 0] = "ApiPartner";
    CreditLinePartnerType[CreditLinePartnerType["HostAgency"] = 1] = "HostAgency";
})(CreditLinePartnerType || (exports.CreditLinePartnerType = CreditLinePartnerType = {}));
//# sourceMappingURL=partner-type.enum.js.map